import * as z from "zod/v4";

export const getReplyToAddress = {
  name: "getReplyToAddress" as const,
  input: z.object({}),
  output: z.object({ email: z.string(), name: z.string() }),
};
